export default __webpack_public_path__ + "static/media/Rowe_Oil.d1eef181.jpg";